import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { PrimeNG } from 'primeng/config';

@Injectable({
  providedIn: 'root',
})
export class PrimengLocaleService {
  constructor(private primengConfig: PrimeNG) {
    const locale = inject(LOCALE_ID);
    this.setPrimeNgLocale(locale.toString());
  }

  private setPrimeNgLocale(locale: string) {
    const locales: Record<string, any> = {
      en: {
        firstDayOfWeek: 0,
        dayNames: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        monthNamesShort: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        today: 'Today',
        clear: 'Clear',
        dateFormat: 'dd/mm/yy',
      },
    };

    const cfg = locales[locale] || locales['en'];
    this.primengConfig.setTranslation(cfg);
  }
}
